var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgNotificationSelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16 14.6V8c0-3-2.2-5.4-5-5.9V1c0-.6-.5-1-1-1S9 .5 9 1v1c-2.9.6-5 3-5 6v6.7l-2.1.8v1.2H18v-1.2l-2-.9zm-8.2 3.2c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2v-.2H7.8v.2z",
    fill: "#e1087e"
  })));
}
export default SvgNotificationSelected;